export const buildInviteLink = (
  location: Pick<Location, 'protocol' | 'host'>,
  campaignId: string,
  inviteCode: string,
) => `${location.protocol}//${location.host}/donor/invite/accept/${campaignId}/${inviteCode}`;

const copyWithExecCommand = (text: string) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  let copied = false;
  try {
    copied = document.execCommand('copy');
  } catch {
    copied = false;
  }
  document.body.removeChild(textarea);
  return copied;
};

const CLIPBOARD_TIMEOUT_MS = 1500;

const withTimeout = <T>(promise: Promise<T>, ms: number) => new Promise<T>((resolve, reject) => {
  const timer = setTimeout(() => reject(new Error('clipboard timeout')), ms);
  promise.then((v) => { clearTimeout(timer); resolve(v); }, (e) => { clearTimeout(timer); reject(e); });
});

// Resolves true when the text reached the clipboard. The async API is preferred; it is missing on
// insecure origins, can reject in Safari/Firefox and can hang behind a permission prompt, so
// execCommand is kept as a fallback.
export const copyText = async (text: string): Promise<boolean> => {
  if (navigator.clipboard?.writeText) {
    try {
      await withTimeout(navigator.clipboard.writeText(text), CLIPBOARD_TIMEOUT_MS);
      return true;
    } catch {
      // fall through to the legacy path
    }
  }
  return copyWithExecCommand(text);
};
